import { render, staticRenderFns } from "./Relationship.vue?vue&type=template&id=3228a78d&scoped=true&"
import script from "./Relationship.vue?vue&type=script&lang=js&"
export * from "./Relationship.vue?vue&type=script&lang=js&"
import style0 from "./Relationship.vue?vue&type=style&index=0&id=3228a78d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3228a78d",
  null
  
)

export default component.exports